import React, { Component, Fragment } from 'react';
import { observer } from 'mobx-react';

import _ from 'lodash';

import { ShopListState } from '../stores/shoplists';
import { confirmState } from '../stores/common';
import { ProviderApi, ShopListApi } from '../stores/apiMethods';

import { TableFilterPage } from './PageTemplates';
import { AddButton, ItemNewHeader, RemoveIconButton } from '../shared/PageComponents';
import { Selectize, TextInput } from '../forms/FormItems';
import { AddPhoneIcon, CalendarIcon, CheckIcon, ProviderIcon, StockIcon, UserIcon } from '../images/icons';

import { toSelectList, getRubs, formatDate, parsePhoneMask } from '../functions';

export class ShopListPage extends Component {
	constructor(props) {
		super(props);
		this.store = new ShopListState();
	}

	componentDidMount() {
		this.getData();
	}

	/** Получение списка закупок */
	getData() {
		this.store.IsSendRequest = false;
		ShopListApi.getList({}, (data) => { this.store.setLists(data); });
	}

	/** Получение закупки по идентификатору
	 * @param {number} id - идентификатор закупки
	 */
	getItem(id) {
		ShopListApi.getById(id, (data) => { this.store.setList(data.Success ? data : undefined); });
	}

	/** Установка идентификатора закупки
	 * @param {number} id - идентификатор закупки
	 */
	setId(id) {
		if (!_.isUndefined(id)) {
			if (id !== -1) this.getItem(id);
		} else {
			this.store.setList(undefined);
			this.getData();
		}
	}

	/** Удаление закупки по идентификатору
	 * @param {number} id - идентификатор закупки
	 */
	removeId(id) {
		if (_.isUndefined(id)) return false;

		var item = _.isEmpty(this.store.Lists) ? "" : _.find(this.store.Lists, { Id: id }),
			text = <span>Вы действительно хотите удалить закупку для <b key="b2">{item.Provider}</b>
				&nbsp;от <b key="b1">«{formatDate(item.Date)}»</b>?</span>;

		confirmState.openConfirm(text, () => {
			ShopListApi.remove(id, () => { this.getData(); });
		});
	}

	/** Отправка закупки по идентификатору
	 * @param {number} id - идентификатор закупки
	 */
	changeState(id) {
		if (_.isUndefined(id)) return false;

		var model = this,
			item = _.isEmpty(this.store.Lists) ? "" : _.find(this.store.Lists, { Id: id }),
			text = <span>Вы действительно хотите отправить закупку для <b key="b2">{item.Provider}</b>
				&nbsp;от <b key="b1">«{formatDate(item.Date)}»</b>?</span>;

		confirmState.openConfirm(text, function () {
			ShopListApi.send(id, function (data) { model.getData(); });
		});
	}

	render() {
		return (
			<div className="page" id="ShopListsPage">
				{this.store.IsSendRequest && _.isUndefined(this.store.ShopList) &&
					<TableFilterPage
						Type="Purchase"
						CanManage={false}

						TableData={this.store.Lists}
						TableColumns={this.store.columns}
						TableFilterable={true}

						setId={this.setId.bind(this)}
						removeId={this.removeId.bind(this)}
						changeState={this.changeState.bind(this)}
						downloadList={(id) => ShopListApi.download(id)}

						getTrProps={(state, rowInfo, column) => {
							return { className: rowInfo && rowInfo.original.Status !== 1 ? "notactive" : "" };
						}}
					/>
				}
				{!_.isUndefined(this.store.ShopList) &&
					<ShopListItem
						ShopList={this.store.ShopList}
						handleClose={() => this.setId()}
					/>
				}
			</div>
		)
	}
}
ShopListPage = observer(ShopListPage);

class ShopListItem extends Component {
	componentDidMount() {
		this.props.ShopList.ButtonLoading = true;
		ProviderApi.getById(this.props.ShopList.ProviderId, (data) => {
			this.props.ShopList.setProvider(data.Success ? data : undefined);
			this.props.ShopList.ButtonLoading = false;
		});
	}

	handleSubmit = (event) => {
		event.preventDefault();

		if (!this.props.ShopList.validate()) return false;

		this.props.ShopList.ButtonLoading = true;
		ShopListApi.save(this.props.ShopList.getData(), (data) => {
			this.props.ShopList.ErrorCode = data.Success ? "SUCCESS_SAVE" : data.ErrorCode;
			this.props.ShopList.SuccessSave = data.Success;
			this.props.ShopList.ButtonLoading = false;

			if (data.Success) setTimeout(() => {
				this.props.ShopList.ErrorCode = "";
				this.props.ShopList.SuccessSave = false;
			}, 3000);
		});
	}

	render() {
		return (
			<section className="item" id="ShopListItem">
				<form onSubmit={this.handleSubmit}>
					<ItemNewHeader
						Title={"Лист закупки"}
						ErrorCode={this.props.ShopList.ErrorCode}
						ButtonLoading={this.props.ShopList.ButtonLoading}
						CanManage={this.props.ShopList.CanManage}
						SuccessSave={this.props.ShopList.SuccessSave}
						handleClose={this.props.handleClose}
					/>
					<div className="shopListGrid">
						<div className="leftColumn">
							<div className="mainRow">
								<MainInfo ShopList={this.props.ShopList} />
								<AmountInfo ShopList={this.props.ShopList} />
							</div>
							{!_.isEmpty(this.props.ShopList.Products) &&
								<ProductsBlock
									Products={this.props.ShopList.Products}
									ProductsList={this.props.ShopList.ProductList}
									CanManage={this.props.ShopList.CanManage}
									CanRemove={this.props.ShopList.CanRemove}

									addProduct={this.props.ShopList.addProduct}
									removeProduct={this.props.ShopList.removeProduct}
								/>
							}
						</div>
						<div className="rightColumn">
							{!_.isEmpty(this.props.ShopList.Contacts) &&
								<ContactsInfo Contacts={this.props.ShopList.Contacts} />
							}
							{!_.isUndefined(this.props.ShopList.WorkHours) &&
								<WorkDaysInfo WorkDays={this.props.ShopList.WorkHours} />
							}
						</div>
					</div>
				</form>
			</section>
		)
	}
}
ShopListItem = observer(ShopListItem);

class MainInfo extends Component {
	render() {
		const shopList = this.props.ShopList;

		return(
			<div className="section mainInfo">
				<UserIcon /><span>{shopList.User}, {formatDate(shopList.Date)}</span>
				<StockIcon /><span>{shopList.Stock}</span>
				<ProviderIcon /><span>{shopList.ProviderName}</span>
				<CheckIcon /><span>{shopList.StatusName}</span>
			</div>
		)
	}
}
MainInfo = observer(MainInfo);

class AmountInfo extends Component {
	render() {
		return(
			<div className="section amount">
				<div className="item">
					<span>Примерная сумма заказа</span>
					<span className={this.props.ShopList.IsNotEnough ? "min" : ""}>
						{getRubs(this.props.ShopList.TotalAmount, true, true, undefined, undefined, undefined, true)}
					</span>
				</div>
				<div className="item">
					<span>Минимальная сумма заказа</span>
					<span>
						{getRubs(this.props.ShopList.MinAmount, true, true, undefined, undefined, undefined, true)}
					</span>
				</div>
			</div>
		)
	}
}
AmountInfo = observer(AmountInfo);

class ContactsInfo extends Component {
	render() {
		return(
			<div className="section contacts">
				<h4 className="sectionTitle"><AddPhoneIcon />Контакты поставщика</h4>
				{_.map(this.props.Contacts, (contact, i) => {
					return (<div className="item" key={"c" + i}>
						<h5>{contact.FIO}</h5>
						{!_.isEmpty(contact.Phone) && <p>+{parsePhoneMask(contact.Phone)}</p>}
						{!_.isEmpty(contact.Email) && <p>{contact.Email}</p>}
					</div>)
				})}
			</div>
		)
	}
}
class WorkDaysInfo extends Component {
	render() {
		return (
			<div className="section workdays">
				<h4 className="sectionTitle"><CalendarIcon />Время приема заказов</h4>
				<p className="comment">Сегодня: {this.props.WorkDays.Today.Date}</p>
				<div className="week">
					{_.map(this.props.WorkDays.Days, (day, i) => {
						return (<Fragment key={"c" + i}>
							<span className={day.IsActive ? "active" : ""}>{day.Name}</span>
							<span className={day.IsActive ? "active" : ""}>с {day.StartTime} до {day.EndTime}</span>
						</Fragment>)
					})}
				</div>
			</div>
		)
	}
}
WorkDaysInfo = observer(WorkDaysInfo);

class ProductsBlock extends Component {
	render() {
		return (
			<div className="section products">
				<h4>Заказ</h4>
				<div className="table">
					<span className="title">Сырье</span>
					<span className="title">Кол-во</span>
					<span className="title">Цена (за ед.)</span>
					<span className="title">Мин.</span>
					<span className="title">НДС</span>
					<span className="title"></span>
					{_.map(this.props.Products, (product, i) => {
						return (<ProductItem key={i} Item={product} Index={i}
							Products={this.props.ProductsList}
							removeProduct={this.props.removeProduct}
							CanManage={this.props.CanManage}
							CanRemove={this.props.CanRemove}
						 />)
					})}
				</div>
				{this.props.CanManage &&
					<AddButton Title="Добавить сырье" onClick={this.props.addProduct} />
				}
			</div>
		)
	}
}
ProductsBlock = observer(ProductsBlock);

class ProductItem extends Component {
	render() {
		return (
			<>
				<Selectize
					Id="ProductId"
					List={toSelectList(this.props.Products)}
					Value={this.props.Item.ProductId}
					RowClass="nomargin"
					onChange={(value, id) => this.props.Item.collect(id, value,
						_.find(this.props.Products, { Id: value }))}
					Disabled={!this.props.CanManage}
				/>
				<TextInput
					Id="Count"
					Type="number"
					Step="0.001"
					Value={this.props.Item.Count}
					Icon={this.props.Item.UnitNet}
					IconType="text"
					RowClass={"nomargin " + (this.props.Item.IsNotEnough ? "min" : "")}
					onChange={(value, id) => this.props.Item.collect(id, value)}
					Disabled={!this.props.CanManage}
				/>
				<TextInput
					Id="Price"
					Value={getRubs(this.props.Item.Price, false, true)}
					RowClass="nomargin"
					Disabled={true}
				/>
				<TextInput
					Id="MinCount"
					Value={this.props.Item.MinCount}
					RowClass="nomargin"
					Disabled={true}
				/>
				<TextInput
					Id="VAT"
					Value={this.props.Item.VATTitle}
					RowClass="nomargin"
					Disabled={true}
				/>
				{this.props.CanRemove ?
					<RemoveIconButton onClick={() => this.props.removeProduct(this.props.Index)} />
					: <span></span>
				}
			</>
		)
	}
}
ProductItem = observer(ProductItem);
